import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles, { createStyles } from '../../core/withStyles';
import Column from '../Column';
const styles = (theme) => createStyles({
    root: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        flex: 1,
    },
});
export const Center = ({ className, classes, children, doubleMargin, }) => (_jsx(Column, Object.assign({ className: cn(classes.root, className), doubleMargin: doubleMargin }, { children: children })));
export default withStyles(styles)(Center);
//# sourceMappingURL=Center.js.map